import { React, useState, useEffect } from "react";
import TrackVisibility from "react-on-screen";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";
import countapi from 'countapi-js';

function About() {
  const [value, setValue] = useState(0);

  const aboutContent = {
    name: "Bolby",
    avatarImage: "/images/avatar-2.svg",
    content:
      "I am Bani Sholih, fullstack developer from Bekasi. I have experience using ReactJs, React Native, Laravel, NodeJs, ExpressJs for developing web and mobile applications",
  };
  
  const progressData = [
    {
      id: 1,
      title: "Development",
      percantage: 95,
      progressColor: "#FFD15C",
    },
    {
      id: 2,
      title: "Travelling",
      percantage: 85,
      progressColor: "#6C6CE5",
    },
    {
      id: 3,
      title: "Learn New Things",
      percantage: 85,
      progressColor: "#FF4C60",
    },
  ];
  
  const counterData = [
    {
      id: 1,
      title: "Website Visit",
      count: `${value}`,
      icon: "icon-people",
    },
    {
      id: 2,
      title: "Cup of coffee",
      count: 5670,
      icon: "icon-cup",
    },
    {
      id: 3,
      title: "Satisfied clients",
      count: 427,
      icon: "icon-fire",
    },
    {
      id: 4,
      title: "Nominees winner",
      count: 35,
      icon: "icon-badge",
    },
  ];

  useEffect(() => {
    countapi.hit('helloimbani.vercel.app', 'visits').then((result) => {
      setValue(result.value)
    });
  }, [])
  
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content}</p>
                  <div className="mt-3">
                    <a href="!#" className="btn btn-default">
                      Download CV
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  {progressData.map((progress) => (
                    <TrackVisibility
                      once
                      key={progress.id}
                      className="progress-wrapper"
                    >
                      <Skill progress={progress} />
                    </TrackVisibility>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
